import { schema } from "normalizr";
import { CollectionPOI } from "./poi";

export const CollectionPOIs = new schema.Array(CollectionPOI);
